import Solutions from './Solutions';

const SolutionsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/soluciones',
            component: Solutions
        }
    ]
};

export default SolutionsConfig;
